import React from 'react'
import { CheckboxAtom } from 'chemistry'
import { ColorSwatch } from './ColorSwatch'
import { StarRating } from './StarRating'
import PromotionFilterValues from './PromotionFilterValues/PromotionFilterValues'
import { CollapsibleListButton } from '../Collapsible/CollapsibleListButton'
import { ALWAYS_VISIBLE_COUNT, useCollapsibleList } from '../Collapsible/useCollapsibleList'
import { getSelectedWithToggle, onSelectFilter } from './CheckListFilter'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { getLabel } from '../utilsFilters'
import { BRICO } from 'client/common/utils'

function parseMinimalRatingValue(value) {
  return Number.parseInt(value.replace('"', '').replace('-inf', ''))
}

export const CheckListItems = ({ items, onSelect, name, format, lang, isDropdownFilter }) => {
  const showNewFilterLabels = useSelector(({ data }) => data?.flags?.showNewFilterLabels)
  return items.map(item => {
    const { value, count, checked } = item
    const label = format === BRICO && showNewFilterLabels ? getLabel(item.label) : item.label
    const isColorSwatch = ['Kleurfamilie', 'Gamme de couleurs'].includes(name)
    const isPromotions = ['Kortingsacties', 'Les meilleurs prix', 'De beste prijzen'].includes(name)
    const isMinimumRating = name === 'product_review_rating'
    const minimalRatingValue = parseMinimalRatingValue(value)
    const getStarRatingFacetLabel = (minimalRatingValue, lang) => {
      if (minimalRatingValue === 5) return ''
      return lang === 'fr' ? 'ou plus' : 'of hoger'
    }
    return (
      <CheckboxAtom
        d='flex'
        onChange={_ => onSelect({ item })}
        isChecked={checked}
        key={value}
        data-testid='checkbox'
        data-value={value}
        _hover={{ backgroundColor: 'lightgray' }}
        {...(isDropdownFilter ? { p: '8px' } : {})}
      >
        <div className='mxd-filter-checkbox flex items-center gap-half'>
          {isColorSwatch && <ColorSwatch value={value} />}
          {isMinimumRating && Number.isFinite(minimalRatingValue) ? (
            <StarRating
              rating={minimalRatingValue}
              lang={lang}
              label={getStarRatingFacetLabel(minimalRatingValue, lang)}
            />
          ) : (
            <span>{isPromotions ? <PromotionFilterValues {...item} format={format} lang={lang} /> : label}</span>
          )}
          <small className='flex items-center' data-count={count}>
            {`(${count})`}
          </small>
        </div>
      </CheckboxAtom>
    )
  })
}

export function CheckListFilterItems({
  id: elemId,
  // uncomment after availability switcher AB test
  // filter: { id, type, title, name, items },
  filter: { name, items },
  filter,
  onChange,
  onClickStickyFilter,
  format,
  lang,
  buttonActiveText,
  buttonInactiveText,
  isDropdownFilter = false,
  className,
  expandableClassName,
  isParentCollapsed,
  filterPosition
}) {
  const alwaysVisibleCount = isDropdownFilter ? 9999 : ALWAYS_VISIBLE_COUNT
  const { stickyItems, collapsibleItems, isListCollapsed, toggleCollapsedList } = useCollapsibleList({
    items,
    isParentCollapsed,
    alwaysVisibleCount
  })
  // uncomment after availability switcher AB test
  // const onSelect = ({ item }) => {
  //   const { selectedItems, wasItemPresent } = getSelectedWithToggle(items, item)
  //   if (!wasItemPresent) selectedItems.push(item)
  //   onClickStickyFilter && onClickStickyFilter({ action: item.checked ? 'unselect' : 'select' })
  //   onChange({
  //     id,
  //     name,
  //     items: selectedItems,
  //     item: { ...item, checked: !item.checked },
  //     type,
  //     title,
  //     filterPosition
  //   })
  // }

  const onSelect = onSelectFilter({
    filter,
    filterPosition,
    onClickStickyFilter,
    onChange,
    getSelectedWithToggleFunc: getSelectedWithToggle
  })

  return (
    <div className={classNames('flex flex-column', className)} id={elemId}>
      <CheckListItems
        items={stickyItems}
        onSelect={onSelect}
        name={name}
        format={format}
        lang={lang}
        isDropdownFilter={isDropdownFilter}
      />
      {collapsibleItems?.length > 0 && (
        <>
          {!isListCollapsed && (
            <div className={classNames('flex flex-column', expandableClassName)}>
              <CheckListItems
                items={collapsibleItems}
                onSelect={onSelect}
                name={name}
                format={format}
                lang={lang}
                isDropdownFilter={isDropdownFilter}
              />
            </div>
          )}
          <CollapsibleListButton
            {...(isDropdownFilter ? { p: '8px' } : {})}
            onClick={e => {
              toggleCollapsedList(e)
              document.querySelector(`#${elemId} *:nth-child(${alwaysVisibleCount}) input`).focus()
            }}
          >
            {isListCollapsed ? buttonInactiveText : buttonActiveText}
          </CollapsibleListButton>
        </>
      )}
    </div>
  )
}
